import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.6358 8.25C12.6358 7.83579 12.3 7.5 11.8858 7.5C11.4716 7.5 11.1358 7.83579 11.1358 8.25V9.97727V11.3005H9.9024H8.24951C7.8353 11.3005 7.49951 11.6363 7.49951 12.0505C7.49951 12.4648 7.8353 12.8005 8.24951 12.8005H9.9024H11.1358V14.1227V15.85C11.1358 16.2642 11.4716 16.6 11.8858 16.6C12.3 16.6 12.6358 16.2642 12.6358 15.85V14.1227V12.8005H13.8693H15.5222C15.9365 12.8005 16.2722 12.4648 16.2722 12.0505C16.2722 11.6363 15.9365 11.3005 15.5222 11.3005H13.8693H12.6358V9.97727V8.25Z",
		fill: "currentColor"
	})
});
export default SvgAdd;
